var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AlcorButton',{staticClass:"new",attrs:{"outline":""},on:{"click":_vm.claimAllPositions}},[_c('i',{staticClass:"el-icon-money"}),_c('div',{staticClass:"fs-14"},[_vm._v("Claim All")])])
}
var staticRenderFns = []

export { render, staticRenderFns }